import { useNavigate } from 'react-router-dom';
import { useAccount } from '../../providers/authenticationProvider';
import { ProfileSettings } from 'insify-remote-component-loader';
import { createBrowserHistory } from 'history';
import { useFeatureFlag } from '../../providers/featureFlagProvider';
import { PageLoader } from '@instech/components';
import { useEffect } from 'react';

export const ProfileSettingsPage = () => {
  const account = useAccount();
  const navigate = useNavigate();
  const history = createBrowserHistory();
  history.push = (to, state) => navigate(to, state);
  history.replace = (to, state) => navigate(to, { ...state, replace: true });

  const featureFlagsLoaded = useFeatureFlag('featureFlagsLoaded');
  const enableProfileSettings = useFeatureFlag('profileSettings');

  useEffect(() => {
    if (featureFlagsLoaded && !enableProfileSettings) {
      navigate('/', { replace: true });
    }
  }, [featureFlagsLoaded, enableProfileSettings, navigate]);

  if (!featureFlagsLoaded) {
    return <PageLoader />;
  }

  if (!enableProfileSettings) {
    return null; // Will redirect, so render nothing
  }

  return (
    <ProfileSettings
      account={account}
      history={history}
    />
  );
};
